import React, { useState, useEffect } from 'react';
import AuditContainer from './components/AuditContainer';
import { User } from 'core/services/user.service';
import { logAmplitudeEventWithProps } from 'core/amplitude/amplitude';
import packageJson from '../../../package.json';

function getStoredUser(): User | undefined {
  try {
    const raw = localStorage.getItem('user');
    return raw ? (JSON.parse(raw) as User) : undefined;
  } catch {
    return undefined;
  }
}

const AuditPage: React.FC = () => {
  const [user] = useState<User | undefined>(getStoredUser);

  useEffect(() => {
    if (!user) return;
    // eslint-disable-next-line no-debugger
    debugger;
    logAmplitudeEventWithProps(
      user.userNameAndCompany,
      {
        company: user.company,
        user: user.userName,
      },
      'Audit Page Viewed',
      {
        elapsed_ms: '0',
        title: 'Audit Log Landing Page',
        componentName: 'AuditPage.tsx',
        version: packageJson.version,
      }
    );
  }, [user]);

  return <AuditContainer />;
};

export default AuditPage;
